<template>
    <div class="link-document-item-demo">
        <div class="link-document-item-demo-head">
            <span>{{setting.title}}</span>
            <div class="link-document-item-demo-head-operate">
                <label @click="$emit('browse')">查看代码</label>
                <label @click="$emit('debug')">在线运行</label>
            </div>
        </div>
        <div class="link-document-item-demo-body">
            <link-document-item-demo-instance :html="html" :css="css" :js="js"/>
        </div>
        <div class="link-document-item-demo-foot" v-if="!!desc">
            <link-document-markdown :value="desc"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "link-document-item-demo",
        props: {
            data: {},
        },
        data() {
            return {
                desc: null,
                ...this.data
            }
        },
    }
</script>

<style lang="scss">
    @include themeify {

        $border-color: #DEE3E8;

        .link-document-item-demo {
            display: flex;
            flex-direction: column;
            border: solid 1px $border-color;
			background-color: white;

            .link-document-item-demo-head {
                border-bottom: solid 1px $border-color;
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                height: 46px;
                line-height: 46px;
                color: #333;
                font-size: 16px;
                background-color: #FBFCFF;
                padding: 0 16px;

                .link-document-item-demo-head-operate {
                    font-size: 12px;
                    color: pl-var(color-primary);

                    label {
                        margin-left: 32px;
                        cursor: pointer;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .link-document-item-demo-body {
                box-sizing: border-box;
            }

            .link-document-item-demo-foot {
                box-sizing: border-box;
                border-top: solid 1px $border-color;
                font-size: 14px;
            }
        }
    }
</style>
